<template>
	<section class="publish-radio text-center" @click="checks">
		<el-checkbox class="radio" v-model="modal" :label="label" :disabled="disabled" ref="radio" />
		<div class="imgs">
			<img :src="src" width="60" height="60"/>
		</div>
		<div class="name" v-if="$slots.default">
			<slot></slot>
		</div>
	</section>
</template>

<script>

	export default {
		name: 'vRadio',

		data() {
			return {

      }
		},

		props: {
			value: {},
			label: {},
      disabled: {
      	type: Boolean,
      	default: false
      },
      src: {},
		},

		computed: {
			modal: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('input', val)
				}
			}
		},

		mounted: function() {
			this.$nextTick(function() {
			})
		},

		methods: {
			checks() {
				this.$refs['radio'].$el.click()
			}
		}
	}
</script>

<style scoped>
.publish-radio {
	display: inline-block;
	padding: 10px 45px 15px;
	border-radius: 5px;
	border: 1px solid #F3F4F6;
	margin-right: 70px;
	cursor: pointer;
}

.publish-radio:last-child {
	margin-right: 0;
}


.publish-radio .name {
	font-size: 14px;
	color: #606266;
}

.imgs{
	margin-bottom: 15px;
}
</style>

<style>
	.publish-radio .el-checkbox__label {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// checkbox.vue?b89dc7f0